export default __webpack_public_path__ + "static/media/background.0973b7f8.svg";